// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getUserAgreementTermsOfServiceRequestToJson, getUserAgreementTermsOfServiceResponseFromJson, setUserAgreementTermsOfServiceRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getUserAgreementTermsOfService(request) {
    const raw = await fetchRpc('partner.v1.PartnerUserAgreementTermsOfService/GetUserAgreementTermsOfService', getUserAgreementTermsOfServiceRequestToJson(request));
    return getUserAgreementTermsOfServiceResponseFromJson(raw);
}
export function getUserAgreementTermsOfService$(request, options) {
    return defer(() => getUserAgreementTermsOfServiceWithTransport$(getGlobalTransport(), request, options));
}
export function getUserAgreementTermsOfServiceWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerUserAgreementTermsOfService/GetUserAgreementTermsOfService', getUserAgreementTermsOfServiceRequestToJson(request), options)
        .pipe(map(resp => getUserAgreementTermsOfServiceResponseFromJson(resp)));
}
export async function setUserAgreementTermsOfService(request) {
    await fetchRpc('partner.v1.PartnerUserAgreementTermsOfService/SetUserAgreementTermsOfService', setUserAgreementTermsOfServiceRequestToJson(request));
}
export function setUserAgreementTermsOfService$(request, options) {
    return defer(() => setUserAgreementTermsOfServiceWithTransport$(getGlobalTransport(), request, options));
}
export function setUserAgreementTermsOfServiceWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerUserAgreementTermsOfService/SetUserAgreementTermsOfService', setUserAgreementTermsOfServiceRequestToJson(request), options)
        .pipe(map(() => undefined));
}
